export default "__VITE_ASSET__045053c8__"